import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';

const SupportCard = ({ title, image, description }: { title: string, image: any, description: string }) => {
  return (
    <Card sx={{ maxWidth: 300, textAlign: 'center', borderRadius:"20px" , padding:"20px" , height:"400px" , margin:"10px", backgroundColor: "var(--section-bg)" }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        <Typography gutterBottom variant="h5" component="div" color={"var(--accent-primary)"} fontWeight={"bold"}>
          {title}
        </Typography>
        <CardMedia
          component="img"
          height="auto"
          image={image}
          alt={title}
          sx={{ maxWidth: '70%', margin: 'auto' , marginTop:"1rem"  }}
        />
        <CardContent>
          <Typography variant="body2" style={{ color: "var(--text-primary)", opacity: "1px", fontSize: "17px" }}>
            {description}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default SupportCard;
